import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';

import { ComponentsModule } from 'src/app/components/components.module';
import { FeaturesService } from 'src/app/components/plans/features.service';
import { CompanyIntegration } from 'src/app/settings/services/integrations/models/integrations.types';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'integration-company-add-card',
  templateUrl: './integration-company-add-card.component.html',
  styleUrl: './integration-company-add-card.component.scss',
  standalone: true,
  imports: [MatButtonModule, MatTooltipModule, ComponentsModule, MatIconModule],
})
export class IntegrationCompanyAddCardComponent {
  @Input({ required: true }) integration!: CompanyIntegration;
  @Input() disabled = false;
  @Input() disabledReason = '';

  @Output() add = new EventEmitter<CompanyIntegration>();

  constructor(private featuresService: FeaturesService) {}

  get showUpgradeNotice(): boolean {
    return (
      !!this.integration.featureName &&
      !this.featuresService.isFeatureAvailable(this.integration.featureName)
    );
  }

  onAdd(): void {
    if (this.disabled) {
      return;
    }
    this.add.emit(this.integration);
  }
}
